/*
 * @Author: your name
 * @Date: 2020-12-22 15:38:12
 * @LastEditTime: 2021-02-02 15:01:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zcjb\src\util\http.js
 */
import axios from 'axios'
import { Message } from 'element-ui'
import store from '../store'
import { getToken } from './auth'

// axios.defaults.withCredentials = true
// axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
const qs = require('qs')
const instance = axios.create({
  withCredentials: true,
  baseURL: process.env.VUE_APP_BASE_API,
  headers: {
    common: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Cache-Control': 'no-cache', // 设置请求不缓存
      Pragma: 'no-cache',
    },
  },
  timeout: 0,
})
instance.interceptors.request.use(
  (config) => {
    // 凭证只认 cookie：刷新后 store 里的 token 可能为空（localStorage 丢失），
    // 但 cookie 仍有效；反过来 cookie 为空时也不能把字符串 "null" 当 token 发给后端。
    const token = getToken()
    if (token) {
      config.headers.token = token
    }
    return config
  },
  (error) => {
    console.log(error)
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  async (response) => {
    const res = response.data
    // blob类型的请求是文件流，没有code
    if (response.config && response.config.responseType === 'blob') {
      return response
    }

    // if the custom code is not 200, it is judged as an error.
    if (res.code !== 200) {
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000,
      })
      // 401代表身份认证失败
      if (res.code === 401 || res.code === 403) {
        store.commit('user/SET_LOGINVISIBLE', true)
        store.dispatch('user/resetToken')
      }
      if (res.data&&res.data.isReturnError) {
        console.log('isReturnError');
        return Promise.reject(res)
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  (error) => {
    console.log(error)
    Message({
      message: error.response.data.msg || error.message,
      type: 'error',
      duration: 5 * 1000,
    })
    return Promise.reject(new Error(error))
  }
)

export default instance
